
define('modules/application/wizard/steps/zoneStep/zonesMenuView',[
  "app",

  // Libs
  "backbone",
  "jqueryUi",
  "./zoneMenuView",
  "./separatorMenuView"
],

function(
  app,
  Backbone,
  jQueryUi,
  ZoneMenuView,
  SeparatorMenuView) {

  var zonesMenuView = Backbone.View.extend({
    keep           : true,
    template       : "application/wizard/steps/zones/menu",
    tagName        : "section",
    className      : "content",
    events         : {
      "click .menuExpanderButton" : "toggle"
    },

    serialize                          : function()                    {
      return { model: this.model };
    },

    cleanup                            : function()                    {
      this.model.off(null, null, this);
    },

    addConstructors                    : function()                    {
      this.ZoneMenuView      = ZoneMenuView;
      this.SeparatorMenuView = SeparatorMenuView;
    },

    initialize                         : function()                    {
      this.addConstructors();
      var that = this;

      this.options.stepEventAggregator.unbind("zone:added",             this.zoneAddedEventHandler);
      this.options.stepEventAggregator.bind("zone:added",               this.zoneAddedEventHandler, this);

      this.options.stepEventAggregator.unbind("zone:removed",           this.removeZone);
      this.options.stepEventAggregator.bind("zone:removed",             this.removeZone, this);

      window.BticinoS4B.eventAggregator.unbind("zone:selectionRequested",             this.zoneSelectionRequestedEventHandler);
      window.BticinoS4B.eventAggregator.bind("zone:selectionRequested",               this.zoneSelectionRequestedEventHandler, this);

      window.BticinoS4B.eventAggregator.unbind("zone:selected",                       this.zoneSelectedEventHandler);
      window.BticinoS4B.eventAggregator.bind("zone:selected",                         this.zoneSelectedEventHandler, this);

      window.BticinoS4B.eventAggregator.unbind("order:changed",                       this.render);
      window.BticinoS4B.eventAggregator.bind("order:changed",                         this.render, this);

      window.BticinoS4B.eventAggregator.unbind("mainControlUnit:chosen",              this.render);
      window.BticinoS4B.eventAggregator.bind("mainControlUnit:chosen",                this.render, this);

      this.options.stepEventAggregator.unbind("collection:initialized", this.render);
      this.options.stepEventAggregator.bind("collection:initialized",   this.render, this);
    },

    zoneSelectedEventHandler           : function(viewToSelect)        {
      this.setSelectedZone(viewToSelect);
    },

    zoneSelectionRequestedEventHandler : function(zoneNumber)          {
      var viewToSelect, selectedModel;

      selectedModel = _.filter(this.model.collection.models, function(zone) {
        return zone.get("number")==zoneNumber;
      });

      if (selectedModel.length==1)
      {
        selectedModel = selectedModel[0];

        viewToSelect = this.getViews(function(view) {
          return view.model==selectedModel;
        });

        if (viewToSelect.__wrapped__.length==1)
          viewToSelect = viewToSelect.__wrapped__[0];
      }
      else
      {
        selectedModel = _.filter(this.model.additionalZones, function(zone) {
          if (zone.attributes)
            return zone.get("number")==zoneNumber;
          else
            return undefined;
        });

        if (selectedModel.length===1)
        {
          selectedModel = selectedModel[0];

          viewToSelect = this.getViews(function(view) {
            if (view.model)
              return view.model.get("number")===selectedModel.get("number");
            else
              return false;
          });

          if (viewToSelect.__wrapped__.length==1)
            viewToSelect = viewToSelect.__wrapped__[0];
        }
        else
          viewToSelect = undefined;
      }

      if (viewToSelect)
        this.setSelectedZone(viewToSelect);
    },

    zoneAddedEventHandler              : function(e)                   {
      this.addZone(e);
    },

    zoneRemovedEventHandler            : function(e)                   {
      this.removeZone(e);
    },

    setSelectedZone                    : function (selectedView)       {

      if (this.model.additionalZones)
        for (var i=0; i<this.model.additionalZones.length; i++) {
          if (this.model.additionalZones[i].role!=="separator")
            this.model.additionalZones[i].set("selected",false);
        }

      this.model.collection.each(function(model) {
        model.set("selected",false);
      });

      this.getViews(function(view){
        view.$el.removeClass("selected");
      });

      if (selectedView.model)
      {
        selectedView.model.set("selected",true);
        selectedView.$el.addClass("selected");
      }
    },

    toggle                             : function (e)                  {

      if(this.$el.hasClass("closed"))
      {
        this.$el.removeClass("closed");
        this.$el.find(".menuCloseButton").empty();
      }
      else
      {
        this.$el.addClass("closed");
        this.$el.find(".menuCloseButton").text(this.model.collection.length);
      }

      e.preventDefault();
    },

    addZone                            : function(attr)                {
      this.render();
    },

    removeZone                         : function(model)               {
      this.sortZones();
      this.options.stepEventAggregator.trigger("order:changed");
      this.render();
    },

    sortZones                          : function()                    {
      var that    = this;
      var counter = 1;

      var currentViewObjects = this.getViews(function(view) {
        return view.model;
      });

      var currentViews = this.$el.find("li:not(.outOfCollection):not(.locked):not(.separator)");
      currentViews.each(function(view){

        var that = this;
        var interestedObjects = _.filter(currentViewObjects.__wrapped__, function(viewObject){
          return viewObject.$el[0]==$(that)[0];
        });

        if (interestedObjects.length==1)
        {
          interestedObjects[0].model.set("number",counter);
          interestedObjects[0].render();
        }

        counter++;

      });
    },

    beforeRender                       : function()                    {
      var firstViewToInsert,
          viewToInsert,
          that              = this,
          i                 = 1,
          additionalZones   = this.model.get("additionalZones");

      for (var j=0; j<additionalZones.length; j++)
      {
        viewToInsert = new that.SeparatorMenuView();
        viewToInsert.name = additionalZones[j].name;
        that.insertView("#zoneList", viewToInsert);
      }

      this.model.collection.each(function(currentModel) {
        currentModel.set("number", i);
        currentModel.set("sortable", true);
        viewToInsert = new that.ZoneMenuView({model : currentModel, stepEventAggregator:that.options.stepEventAggregator});
        that.insertView("#zoneList", viewToInsert);
        i++;
      });

      window.BticinoS4B.eventAggregator.trigger("zone:selected", viewToInsert);
    },

    afterRender                        : function()                    {
      var that        = this;

      if (this.model.collection.at(0))
      {
        $(this.el).find(".zones").sortable({
          update: function(event, ui) { that.sortZones(); that.options.stepEventAggregator.trigger("order:changed");},
          items : "li:not(.outOfCollection)"
        });
      }

      $(this.el).find(".zones").disableSelection();

      var menuView        = this.$el;
      var menuTitleView   = menuView.find(".titleBar");
      var menuZoneListView= menuView.find("#zoneList");

      // menuZoneListView.height(menuView.height()-menuTitleView.height());
    }
  });

  // Required, return the module for AMD compliance
  return zonesMenuView;

});